import { styled } from '@mui/material/styles'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'

export const StyledBottomNavigationAction = styled(BottomNavigationAction)(
	({ theme, backButton }) => ({
		color: theme.palette.primary.main,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		height: '100%',
		padding: '5px',
		flexDirection: 'column',
		lineHeight: '1.25rem', // 20px
		letterSpacing: ' 0.0125rem', // 0.2px
		'&.Mui-selected': {
			backgroundColor: theme.palette.secondary.orange,
			color: theme.palette.white,
			'> .MuiSvgIcon-root': {
				color: theme.palette.white
			}
		},
		'.MuiBottomNavigationAction-label': {
			fontWeight: 400,
			[theme.breakpoints.between(0, 434)]: {
				fontSize: backButton ? '0.51rem' : '0.6875rem'
			},

			[theme.breakpoints.up('sm')]: {
				fontSize: '0.875rem' // 14px
			}
		},
		[theme.breakpoints.up('sm')]: {
			padding: '10px',
			gap: '4px'
		}
	})
)
